import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { formatDateFR } from "@/lib/format";
import { createColumn } from "@/lib/table/columnFactory";
import type { LeaveRequest } from "./types";

export const dureeColumn = createColumn<LeaveRequest>({
  accessorKey: "nombreJours",
  header: ({ column }) => <DataTableColumnHeader column={column} title="Durée" />,
  cell: ({ row }) => {
    const debut = new Date(row.original.dateDebut);
    const fin = new Date(row.original.dateFin);
    const isJourneeComplete = row.original.isJourneeComplete;
    const isSameDay = formatDateFR(debut) === formatDateFR(fin);
    if (!isJourneeComplete && isSameDay) {
      const diffMs = fin.getTime() - debut.getTime();
      const diffH = diffMs / (1000 * 60 * 60);
      if (diffH === Math.floor(diffH)) {
        return `${diffH}h`;
      }
      return `${diffH.toFixed(1)}h`;
    }
    return `${row.original.nombreJours} jours`;
  },
});
